// extracted by mini-css-extract-plugin
export default {"loader":"loading-circle_loader__6HKco","spin":"loading-circle_spin__l5Qg1"};